// This file is used to provide cover access methods to build settings that may be migrated in the
// future.
import { CLEAR_SAF_DECLINES, ENABLE_MASTERCARD_ANIMATION, ENABLE_VISA_ANIMATION } from '../constants'

const isEnabled = (value) => {
  return value === true || value === 'true'
}

export const enableVisaAnimation = () => {
  return isEnabled(ENABLE_VISA_ANIMATION)
}

export const getSensoryBrandingEnabled = () => {
  return {
    visa: enableVisaAnimation(),
    mastercard: enableMasterCardAnimation(),
  }
}

export const enableMasterCardAnimation = () => {
  return isEnabled(ENABLE_MASTERCARD_ANIMATION)
}

export const getTransactionBrandingConfig = () => {
  return {
    mcAnimationEnabled: enableMasterCardAnimation(),
    sensoryBrandingEnabled: getSensoryBrandingEnabled(),
  }
}

export const enableClearSafDeclines = () => {
  return isEnabled(CLEAR_SAF_DECLINES)
}
